import VDMDashboardLNGConsumption from "components/app/vdmdashboard/lng-consumption/VDMDashboardLNGConsumption";
import React from "react";

type ScreenVDMDashboardLNGConsumptionType = React.PropsWithChildren<{
	match: {
		params: {
			vesselId: string;
		};
	};
}>;
const ScreenVDMDashboardLNGConsumption: React.FC<
	ScreenVDMDashboardLNGConsumptionType
> = (props: ScreenVDMDashboardLNGConsumptionType) => {
	return <VDMDashboardLNGConsumption vesselId={props.match.params.vesselId} />;
};

export default ScreenVDMDashboardLNGConsumption;
